import React, { useState } from 'react';
import { animated, useSpring } from 'react-spring';
import video1 from '../../../assets/videos/BrandHeroVideos/Hero_Brand_01.mp4';
import video2 from '../../../assets/videos/BrandHeroVideos/Hero_Brand_02.mp4';
import video3 from '../../../assets/videos/BrandHeroVideos/Hero_Brand_03.mp4';
import './BrandHero.css';

const BrandHero = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  // Array of videos to randomly select from
  const videos = [video1, video2, video3];

  // Select random video on component mount
  const [selectedVideo] = useState(() => {
    const randomIndex = Math.floor(Math.random() * videos.length);
    return videos[randomIndex];
  });

  const descriptionAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 20 },
    delay: 300, // Description appears after heading
  });

  // Bounce-in load animation for the main text
  const bounceIn = useSpring({
    from: { opacity: 0, transform: 'translateY(-50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 25 },
  });

  // Animation for video load-in
  const videoAnimation = useSpring({
    opacity: isVideoLoaded ? 1 : 0,
    transform: isVideoLoaded ? 'translateY(0px)' : 'translateY(50px)',
    config: { tension: 120, friction: 20 },
  });

  // Handle video load event
  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div className="brand-hero">
      <div className="brand-hero-overlay">
        {/* Apply bounce-in animation to the main text */}
        <animated.div style={bounceIn} className="brand-hero-text">
          <h1>
            RE-DEFINING ADVERTISING THROUGH <br />
            CREATIVE AS TARGETING
          </h1>

          {/* Commented out transitioning word functionality for future use */}
          {/* 
                    <div className="changing-word-container">
                        {transitions((style, word) => (
                            <animated.span
                                style={style}
                                className="changing-word"
                            >
                                {word}
                            </animated.span>
                        ))}
                    </div>
                    */}
        </animated.div>

        <animated.p
          style={descriptionAnimation}
          className="brand-hero-description"
        >
          The answer to advertising in the algorithmic era.
        </animated.p>

        <animated.div
          style={videoAnimation}
          className="brand-hero-video-container"
        >
          <video
            className="brand-hero-video"
            onLoadedData={handleVideoLoad}
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={selectedVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </animated.div>
      </div>
    </div>
  );
};

export default BrandHero;
